import * as React from "react"

import Layout from "../components/layout"
import "../static/style/all.css"
import not_found_image from '../static/assets/images/not_found.svg'

const NotFoundPage = () => {

return (
  <Layout>
      <div className="text-center" style={{marginTop: "70px"}}>
          <div className="notfound-img d-flex justify-content-center">
              <img src={not_found_image}/>
          </div>
          <h1 className="text-accent head-text mt-3">Page not found</h1>
          <div className="d-flex justify-content-center my-3 notfound-text">
              <p className="lh-base subtext">Convert PowerPoint presentations to multiple file formats. Split, merge protect or make a video out of presentations.</p>
          </div>
          <a href="./">
              <div className="w-100 d-flex justify-content-center">
                  <button className="btn request-btn text-white">Go to main page</button>
              </div>
          </a>
      </div>
  </Layout>);
}

export const Head = () => {
    return (
        <>
            <meta charSet="UTF-8"/>
            <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
            <link rel="icon" type="image/x-icon" href="../static/assets/images/logo.png"/>
            <title>404</title>
        </>
    );
}

export default NotFoundPage
